@if (
  authService.isAdmin ||
  authService.isAuditAdmin ||
  authService.isNewsArchiveAdmin ||
  authService.isContractAdmin ||
  authService.isNewsAdmin ||
  authService.isUserTourAdmin ||
  authService.isUxAdmin
) {
  <button type="button" mat-mini-fab [matMenuTriggerFor]="adminMenu">
    <mat-icon>admin_panel_settings</mat-icon>
  </button>

  <mat-menu #adminMenu>
    @if (authService.isAdmin) {
      <div [disabled]="true" mat-menu-item>Administration</div>
      <mat-divider></mat-divider>
    }
    @if (authService.isAdmin || authService.isNewsAdmin) {
      <a [routerLink]="['/admin/news-article']" mat-menu-item>News</a>
      <a [routerLink]="['/admin/news-research']" mat-menu-item>News Research</a>
    }
    @if (authService.isAdmin || authService.isUserTourAdmin) {
      <a [routerLink]="['/admin/user-tour']" mat-menu-item>User-Tours</a>
    }
    @if (authService.isAdmin) {
      <a [routerLink]="['/admin/news-source']" mat-menu-item>News-Sources</a>
      <mat-divider></mat-divider>
      <a [routerLink]="['/admin/company']" mat-menu-item>Companies</a>
      <a [routerLink]="['/admin/user']" mat-menu-item>Users</a>
      <a [routerLink]="['/admin/document']" mat-menu-item>Documents</a>
      <a [routerLink]="['/admin/attio']" mat-menu-item>Attio Matching</a>
      <mat-divider></mat-divider>
      <a [routerLink]="['/admin/legal-norm']" mat-menu-item>Legal-Norms</a>
      <a [routerLink]="['/admin/risk-category']" mat-menu-item>Risk-Categories</a>
      <a [routerLink]="['/admin/attribute-definition']" mat-menu-item>Attribute-Definitions</a>
      <a [routerLink]="['/admin/attribute-property']" mat-menu-item>Attribute Properties</a>
      <a [routerLink]="['/admin/document-type']" mat-menu-item>Document-Types</a>
      <a [routerLink]="['/admin/site-type']" mat-menu-item>Site-Types</a>
      <a [routerLink]="['/admin/location']" mat-menu-item>Locations/GeoShapes</a>
      <mat-divider></mat-divider>
      <a [routerLink]="['/admin/generic-setting']" mat-menu-item>Generic-Settings</a>
      <a [routerLink]="['/admin/email-template']" mat-menu-item>Email-Templates</a>
      <a [routerLink]="['/admin/eudr-credential']" mat-menu-item>EUDR-Credentials</a>
      <a [routerLink]="['/admin/whisp']" mat-menu-item>Whisp Jobs</a>
      <mat-divider></mat-divider>
      <a [routerLink]="['/admin/tools']" mat-menu-item>Admin Tools</a>
    }
    @if (authService.isAuditAdmin) {
      <a [routerLink]="['/admin/audit-log']" mat-menu-item>Audit Log</a>
    }
    @if (authService.isUxAdmin) {
      <a [routerLink]="['/admin/ux-sessions']" mat-menu-item>UX Sessions</a>
    }
    @if (authService.isNewsArchiveAdmin) {
      <a [routerLink]="['/admin/news-archive']" mat-menu-item>News Archive</a>
    }
    @if (authService.isContractAdmin) {
      <a [routerLink]="['/admin/mandate']" mat-menu-item>EUDR Mandates</a>
    }
  </mat-menu>
}
